// One-tap "report this question" → moderation queue. Self-contained and additive:
// drop <ReportButton questionId={id} /> anywhere a question is shown.
import { useState } from 'react';
import { apiPost } from '@/lib/api';

const REASONS = [
  { value: 'wrong_answer', label: 'Wrong answer' },
  { value: 'typo', label: 'Typo / formatting' },
  { value: 'unclear', label: 'Unclear / ambiguous' },
  { value: 'off_syllabus', label: 'Off-syllabus' },
  { value: 'other', label: 'Something else' },
];

export function ReportButton({ questionId }: { questionId: string }) {
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  async function report(reason: string) {
    setBusy(true);
    try {
      await apiPost(`/questions/${questionId}/report`, { reason });
      setDone(true);
      setOpen(false);
    } catch {
      /* best-effort: reporting must never disrupt the flow */
    } finally {
      setBusy(false);
    }
  }

  if (done) return <span className="text-xs text-ink-faint">⚑ Reported — thanks!</span>;

  return (
    <div className="relative inline-block">
      <button type="button" className="text-xs text-ink-faint underline" onClick={() => setOpen((o) => !o)}>
        ⚑ Report
      </button>
      {open && (
        <div className="absolute right-0 z-20 mt-1 w-48 rounded-card border border-line bg-card p-1 shadow-lg">
          <div className="px-2 py-1 text-fs-10 font-semibold uppercase tracking-wide text-ink-faint">What’s wrong?</div>
          {REASONS.map((r) => (
            <button
              key={r.value}
              type="button"
              disabled={busy}
              onClick={() => report(r.value)}
              className="block w-full rounded px-2 py-1.5 text-left text-xs text-ink hover:bg-paper"
            >
              {r.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
